import BoxMui from '@mui/material/Box';
import { styled } from '@mui/system';

export const Container = styled('div')(
    ({ theme }) => `
        width: 100%;
`);

export const Box = styled(BoxMui)(
    ({ theme }) => `
        display: flex;
        flex-direction: column;
        gap: .5rem;

        @media(min-width: ${theme.breakpoints.values.md}px) {
            flex-direction: row;
        }
`);